// @ts-expect-error: no types
import * as ReferenceObjectTypes from 'reference-resolvers/constants/ReferenceObjectTypes';

// Adapted from `customer-data-table/static/js/constants/referencedObjectTypes.js
export const referencedObjectTypes = Object.assign({
  hubspot_owner_id: ReferenceObjectTypes.OWNER,
  hubspot_team_id: ReferenceObjectTypes.TEAM
}, ReferenceObjectTypes);